/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { ManagedVmsContext } from '../contexts/ManagedVmsContext';

export const useManagedVmsStore = () => useContext(ManagedVmsContext);
